// Author YuJiaBei
// Date 2020-10-10 14:00:25

class SithMesMstShift {
constructor({
        id = null,
        shiftCode = '',
        name = '',
        remark = ''}
= {}) {
    this.id = id;
    this.shiftCode = shiftCode;
    this.name = name;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesMstShift();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'shiftCode',
        label: 'label.sith.mst.sithMesMstShift.grid.shiftCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'name',
        label: 'label.sith.mst.sithMesMstShift.grid.name',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.mst.sithMesMstShift.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    shiftCodeFilter : "",
    nameFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'shiftCodeFilter',
        label: 'label.sith.mst.sithMesMstShift.filter.shiftCode',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'nameFilter',
        label: 'label.sith.mst.sithMesMstShift.filter.name',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'shiftCode',
        label: 'label.sith.mst.sithMesMstShift.entity.shiftCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'name',
        label: 'label.sith.mst.sithMesMstShift.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'remark',
        label: 'label.sith.mst.sithMesMstShift.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {SithMesMstShift, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
